import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  dashboardCell: {
    position: 'relative',
    '&:hover $configButton': {
      opacity: 1,
    },
  },
  configButton: {
    position: 'absolute !important',
    top: '12px',
    right: '12px',
    opacity: 0,
    zIndex: 10,
    transition: 'opacity 0.2s ease, background-color 0.2s, transform 0.2s !important',
    backgroundColor: theme.palette.type === 'dark' ? '#27272A !important' : '#F4F5F7 !important',
    color: `${theme.palette.text.secondary} !important`,
    padding: '6px !important',
    minWidth: 'auto !important',
    borderRadius: '50% !important',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' ? '#3F3F46 !important' : '#E4E7EB !important',
      transform: 'rotate(45deg)',
    },
  },
  tableCard: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '12px',
    padding: theme.spacing(2.5),
    boxShadow: 'none',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
  },
  tableTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: '2px',
    paddingRight: '32px',
  },
  tableSubtitle: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  cellLoadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: theme.palette.type === 'dark' ? 'rgba(14, 14, 14, 0.7)' : 'rgba(255, 255, 255, 0.7)',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 5,
  },
  mobileCardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(1),
  },
  mobileCard: {
    cursor: 'pointer',
    backgroundColor: theme.palette.type === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(10, 37, 64, 0.025)',
    border: theme.palette.type === 'dark'
      ? '1px solid rgba(255, 255, 255, 0.06)'
      : '1px solid rgba(10, 37, 64, 0.05)',
    borderRadius: '8px',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
      transform: 'translateY(-2px)',
      backgroundColor: theme.palette.type === 'dark'
        ? 'rgba(255, 255, 255, 0.06)'
        : 'rgba(10, 37, 64, 0.05)',
      borderColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(10, 37, 64, 0.1)',
    },
  },
  mobileCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(1),
  },
  mobileCardId: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
  },
  mobileCardTitle: {
    fontWeight: 500,
    fontSize: '0.95rem',
    color: theme.palette.text.primary,
  },
  mobileCardSub: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
  },
  mobileCardFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    borderTop: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  mobileCardDate: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
  },
  emptyState: {
    padding: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.type === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(10, 37, 64, 0.025)',
    borderRadius: '8px',
    border: theme.palette.type === 'dark'
      ? '1px dashed rgba(255, 255, 255, 0.1)'
      : '1px dashed rgba(10, 37, 64, 0.1)',
  },
}))

export default useStyles
